<template>
  <div>
    <div class="failure_head">
      <img src="@/assets/images/failure.png" alt />
      <p>支付失败</p>
      <p>支付遇到问题，请尝试重新支付</p>
      <div class="btn_again" @click="onClickOrder">重新支付</div>
      <div class="btn_return btn_again" @click="onClickOrder">返回订单</div>
    </div>
  </div>
</template>

<script>
import { getPayResult } from '@/api/themedata.js'
import increaseFpClickCountMixin from '@/mixins/increaseFpClickCountMixin'
import Cookies from 'js-cookie'

export default {
  name: 'PayFailure',
  mixins: [increaseFpClickCountMixin],
  data() {
    return {
      id: 0,
      token: this.$route.query.token,
      resule: {
        amount: 0,
        orderId: 0,
        success: true,
      },
    }
  },
  created() {
    // console.log('进来看链接路由', this.token, 'cookie', Cookies.get('token'))
    // if (this.token) {
    //   Cookies.set('token', this.token)
    //   console.log('写入后再次看', Cookies.get('token'))
    // }
    window.document.title = '失败'
  },
  mounted() {
    this.id = this.$route.query.id
    this.getData()
  },
  methods: {
    getData() {
      getPayResult(this.id).then((res) => {
        if (res.data.code === 200) {
          this.resule = res.data.data
        }
      })
    },
    onClickOrder() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'ShowTabBarMethod', '')
        setTimeout(() => {
          this.$callApp('Android', 'GoOrderListMethod', '')
        }, 200)
        this.$callApp('iOS', 'GoOrderListMethod', '')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.failure_head {
  margin: 84px 50px 0;

  img {
    margin-left: 113.5px;
    width: 50px;
    height: 50px;
  }

  p:nth-of-type(1) {
    color: #f56c6c;
    margin: 10px 0px 15px 112.5px;
    font-size: 13px;
  }

  p:nth-of-type(2) {
    color: #adadad;
    margin: 0px 0px 200px 53.5px;
    font-size: 12px;
  }

  .btn_again {
    background-color: #FF986D;
    color: #fff;
    width: 275px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 20px;
    border-radius: 25px;
    margin-bottom: 15px;
  }

  .btn_return {
    background: #fff;
    color: #FF986D;
    border: 1px solid #FF986D;
  }
}
</style>
